import {
  ColumnDefinition,
  convertToFilterWithPlus,
  getFilters,
  getOrder,
  getSearchFilter,
  getSearchOrder,
  getServerFieldSectionWhere,
  getServerQueryFilter,
  isFilterExist,
  isSortExist,
  TABLE_SORT_DIRECTION,
} from 'Src/helpers/table';
import { DATE_INTERVAL, FILTER_TYPE, FIRST_PAGE } from 'Src/consts/table';
import { AppUser } from 'Src/views/App/App';
import { History, Location } from 'history';
import { Customer } from 'Src/models/customers';
import { Component } from 'react';
import { parse } from 'query-string';
import * as BPromise from 'bluebird';
import {
  getAllCustomerWithStudents,
  getCustomerWithStudents,
  getCustomerWithStudentsCount,
} from 'Src/services/superadmin/customers';
import { addCustomerPermissionsBulkImageId } from 'Src/services/superadmin/customerPermissions';
import * as React from 'react';
import { Grid } from 'Src/components/Grid/Grid';
import { Loader } from 'Src/components/Loader/Loader';
import { SimpleModal } from 'Src/components/SimpleModal/SimpleModal';
import { CustomerStudentsForm } from './CustomerStudentsForm/CustomerStudentsForm';
import { CustomerBulkImageIdForm } from './CustomerBulkImageIdForm/CustomerBulkImageIdForm';
import { approveStudent } from '../../../../../../../services/superadmin/students';
import {
  approvedAllStudentsStatusNoMatch,
  deleteCustomerStudent,
  deleteCustomerStudentNoNotification,
  getAllCustomerStudents,
  updateRequestStatusCustomerStudent,
} from '../../../../../../../services/superadmin/customerStudents';
import { Student } from '../../../../../../../models/students';
import * as propz from 'propz';
import { customerEmailCell, getReasonsForCancellation, getNotifiedStatus } from '../../../../../../../helpers/cell';
import {
  getSelectOptionForNoAutoAcceptReason,
  getSelectOptionForRequestStatus,
} from '../../../../../../../helpers/select';
import {
  getCustomerName,
  getCustomerStudentForms,
  getCustomerStudentsRequestStatus,
  getCustomerWithStudentSchoolsView,
  getCustomerWithStudentsView,
  getUpdatedAtWithTime,
} from '../../../../../../../helpers/accessor';
import { STUDENT_REQUEST_STATUS } from '../../../../../../../consts/customer';

const COLUMNS: ColumnDefinition[] = [
  {
    text: 'Email',
    field: 'email',
    isSort: true,
    type: FILTER_TYPE.NONE,
    cell: customerEmailCell,
  },
  {
    text: 'Customer',
    field: 'customerName',
    isSort: false,
    type: FILTER_TYPE.TEXT,
    accessor: getCustomerName,
  },
  {
    text: 'Status',
    field: 'requestStatus',
    isSort: false,
    type: FILTER_TYPE.MULTISELECT,
    accessor: getCustomerStudentsRequestStatus,
  },
  {
    text: 'Students',
    field: 'students',
    isSort: false,
    type: FILTER_TYPE.NONE,
    accessor: getCustomerWithStudentsView,
  },
  {
    text: 'Schools',
    field: 'schools',
    isSort: false,
    type: FILTER_TYPE.NONE,
    accessor: getCustomerWithStudentSchoolsView,
  },
  {
    text: 'Class',
    field: 'forms',
    isSort: false,
    type: FILTER_TYPE.NONE,
    accessor: getCustomerStudentForms,
  },
  {
    text: 'Date',
    field: 'updatedAt',
    isSort: true,
    type: FILTER_TYPE.DATE_INTERVAL,
    accessor: getUpdatedAtWithTime,
  },
  {
    text: 'No auto-accept reason',
    field: 'noAutoAcceptReason',
    isSort: false,
    type: FILTER_TYPE.MULTISELECT,
    cell: getReasonsForCancellation,
  },
  {
    text: 'Notified',
    field: 'imagesPendingNotified',
    isSort: false,
    type: FILTER_TYPE.NONE,
    cell: getNotifiedStatus,
  },
];

interface Props {
  user: AppUser;
  history: History;
  location: Location;
}

interface State {
  items: Customer[];
  currentPage: number;
  selectedItems: Customer[];
  sortDirection: TABLE_SORT_DIRECTION;
  sortColumnsName: string;
  isShowFilter: boolean;
  isDataFiltered: boolean;
  filters: any;
  isLoading: boolean;
  isSelectAllChecked: boolean;
  total: number;
  basePath: string;
  isCustomerStudentsFormModalOpen: boolean;
  isBulkImageModalOpen: boolean;
  isBulkImageConfirmationOpen: boolean;
  bulkAddedCount: number;

  isErrorModalOpen: boolean;
  errorMessage: string;

  students: Student[];
}

export class CustomerWithStudents extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      items: [],
      currentPage: FIRST_PAGE,
      selectedItems: [],
      sortDirection: '',
      sortColumnsName: '',
      isShowFilter: false,
      isDataFiltered: false,
      filters: {},
      isLoading: false,
      isSelectAllChecked: false,
      total: 0,
      basePath: '',
      isCustomerStudentsFormModalOpen: false,
      isBulkImageModalOpen: false,
      isBulkImageConfirmationOpen: false,
      bulkAddedCount: 0,
      isErrorModalOpen: false,
      errorMessage: '',

      students: [],
    };
  }

  componentDidMount() {
    this.setState({
      isLoading: true,
    });

    this.setItems();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.location.search !== this.props.location.search) {
      this.setState({
        isLoading: true,
      });
      this.setItems();
    }
  }

  setItems() {
    const { history, user } = this.props;

    const search = parse(history.location.search);
    const page = typeof search.page !== 'undefined' ? Number(search.page) : FIRST_PAGE;

    let sortDirection = '';
    let sortColumnsName = '';

    if (typeof search.order === 'string') {
      [sortColumnsName, sortDirection] = search.order.split(':');
    }

    const sortByFieldExist = sortColumnsName !== '';
    const sortDirectionExist = sortDirection !== '';

    const filters = getFilters(COLUMNS, search);

    const isShowFilter = isFilterExist(filters);
    const isDataFiltered = isFilterExist(filters);

    const where = getServerFieldSectionWhere(filters);

    const order = sortByFieldExist && sortDirectionExist ? `${sortColumnsName} ${sortDirection}` : undefined;
    const serverQueryFilter = getServerQueryFilter(page, where, order);

    const getItemsPromise = getCustomerWithStudents(user, serverQueryFilter);
    const getItemsCountPromise = getCustomerWithStudentsCount(user, where);

    const promises = [getItemsCountPromise, getItemsPromise];

    return BPromise.all(promises).then(([countObj, items]) => {
      this.setState({
        currentPage: page,
        sortDirection: sortDirection as TABLE_SORT_DIRECTION,
        sortColumnsName: sortColumnsName,
        isShowFilter: isShowFilter,
        isDataFiltered: isDataFiltered,
        filters: filters,
        items: items,
        total: countObj.count,
        basePath: history.location.pathname,
        isLoading: false,
      });

      return true;
    });
  }

  setCurrentPageParams = (currentPage: number): void => {
    let search = [];

    const { filters, sortColumnsName, sortDirection } = this.state;

    if (currentPage !== 1) {
      search.push(`page=${currentPage}`);
    }

    if (isSortExist(sortDirection, sortColumnsName)) {
      search.push(getSearchOrder(sortDirection, sortColumnsName));
    }

    const isFilter = isFilterExist(filters);

    if (isFilter) {
      search.push(getSearchFilter(filters));
    }

    this.props.history.push({
      pathname: this.state.basePath,
      search: search.join('&'),
    });
  };

  onItemClick = (index: number): void => {
    const { items, selectedItems } = this.state;
    const selectedItem = items[index];

    const selectedItemIndex = selectedItems.findIndex(item => selectedItem.id === item.id);
    let selectedItemsUpdated = [...selectedItems];

    if (selectedItemIndex !== -1) {
      selectedItemsUpdated.splice(selectedItemIndex, 1);
    } else {
      selectedItemsUpdated.push(selectedItem);
    }

    this.setState({
      selectedItems: selectedItemsUpdated,
    });
  };

  onSelectAllOnPageClick = (): void => {
    const { items, selectedItems } = this.state;

    const itemsFiltered = items.filter(item => {
      return selectedItems.every(selectedItem => selectedItem.id !== item.id);
    });

    const selectedItemsNext = [...selectedItems, ...itemsFiltered];

    this.setState({
      selectedItems: selectedItemsNext,
      isSelectAllChecked: true,
    });
  };

  onSelectAllClick = (): void => {
    const { selectedItems, filters } = this.state;

    this.setState({
      isLoading: true,
    });

    const user = this.props.user;

    const where = getServerFieldSectionWhere(filters);

    getAllCustomerWithStudents(user, where).then(items => {
      const itemsFiltered = items.filter(item => {
        return selectedItems.every(selectedItem => selectedItem.id !== item.id);
      });

      const selectedItemsNext = [...selectedItems, ...itemsFiltered];

      this.setState({
        selectedItems: selectedItemsNext,
        isSelectAllChecked: true,
        isLoading: false,
      });
    });
  };

  onUnselectAllClick = (): void => {
    this.setState({
      selectedItems: [],
      isSelectAllChecked: false,
    });
  };

  onTableSortClick = (sortField: string): void => {
    const { sortDirection, sortColumnsName, filters } = this.state;

    const order = getOrder(sortField, sortDirection, sortColumnsName);

    let search = [];
    search.push(`order=${sortField}:${order}`);

    const isFilter = isFilterExist(filters);

    if (isFilter) {
      search.push(getSearchFilter(filters));
    }

    this.props.history.push({
      pathname: this.state.basePath,
      search: search.join('&'),
    });
  };

  onTableFilterChange = (event, filterField: string, options?): void => {
    const filterValue = event.target.value;
    const filters = this.state.filters;
    const currentFilterField = filters[filterField];

    let nextFilters = { ...filters };

    if (typeof options !== 'undefined') {
      switch (options) {
        case DATE_INTERVAL.FROM:
          nextFilters = {
            ...nextFilters,
            [filterField]: {
              ...currentFilterField,
              from: filterValue,
            },
          };
          break;
        case DATE_INTERVAL.TO:
          nextFilters = {
            ...nextFilters,
            [filterField]: {
              ...currentFilterField,
              to: filterValue,
            },
          };
          break;
      }
    } else {
      const filter = COLUMNS.find(col => col.field === filterField);
      const filterType = filter.type;

      if (filterType === FILTER_TYPE.MULTISELECT) {
        const options = event.target.options;
        const value = [];
        for (let i = 0; i < options.length; i++) {
          if (options[i].selected) {
            value.push(options[i].value);
          }
        }
        nextFilters = {
          ...nextFilters,
          [filterField]: value,
        };
      } else {
        nextFilters = {
          ...nextFilters,
          [filterField]: filterValue,
        };
      }
    }

    this.setState({
      filters: nextFilters,
    });
  };

  onApplyFilterClick = (): void => {
    const { filters, sortDirection, sortColumnsName } = this.state;
    let search = [];

    if (isSortExist(sortDirection, sortColumnsName)) {
      search.push(getSearchOrder(sortDirection, sortColumnsName));
    }

    const isFilter = isFilterExist(filters);

    const filtersConverted = convertToFilterWithPlus(filters);

    if (isFilter) {
      search.push(getSearchFilter(filtersConverted));
    }

    this.setState({
      selectedItems: [],
      isSelectAllChecked: false,
    });

    this.props.history.push({
      pathname: this.state.basePath,
      search: search.join('&'),
    });
  };

  onClearFilterClick = (): void => {
    this.setState({
      selectedItems: [],
      isSelectAllChecked: false,
    });

    this.props.history.push({
      pathname: this.state.basePath,
      search: '',
    });
  };

  onTableFilterClick = (event): void => {
    event.preventDefault();

    const isShowFilter = this.state.isShowFilter;

    this.setState({
      isShowFilter: !isShowFilter,
    });
  };

  onCloseErrorClick = () => {
    this.setState({
      isErrorModalOpen: false,
      errorMessage: '',
      isLoading: true,
    });
    this.setItems();
  };

  showBulkImageModal = () => this.setState({ isBulkImageModalOpen: true });

  hideBulkImageModal = () => this.setState({ isBulkImageModalOpen: false, errorMessage: '' });

  showBulkImageConfirmation = (count: number) =>
    this.setState({ isBulkImageConfirmationOpen: true, bulkAddedCount: count });

  hideBulkImageConfirmation = () => this.setState({ isBulkImageConfirmationOpen: false });

  onApproveStudentsClick = () => {
    const { user } = this.props;
    const { selectedItems } = this.state;
    const [customer] = selectedItems;
    this.setState({
      isLoading: true,
    });
    getAllCustomerStudents(user, customer.id)
      .then(students => {
        this.setState({
          students: students,
          isCustomerStudentsFormModalOpen: true,
          isLoading: false,
        });
      })
      .catch(error => {
        const errorText = propz.get(error, ['response', 'data', 'details', 'text'], '');
        console.error(errorText);
        this.setState({
          isLoading: false,
          isErrorModalOpen: true,
          errorMessage: errorText,
        });
      });
  };

  onAutomatchStudentsClick = () => {
    const { user } = this.props;
    this.setState({
      isLoading: true,
    });

    approvedAllStudentsStatusNoMatch(user)
      .then(students => {
        this.setState({
          isLoading: false,
        });
        this.setItems();
      })
      .catch(error => {
        const errorText = propz.get(error, ['response', 'data', 'details', 'text'], '');
        console.error(errorText);
        this.setState({
          isLoading: false,
          isErrorModalOpen: true,
          errorMessage: errorText,
        });
      });
  };

  onCancelCustomerStudentsFormButtonClick = () => {
    this.setState({
      isCustomerStudentsFormModalOpen: false,
    });
  };

  onPostponeStudentRequestClick = (id, data) => {
    const { user } = this.props;
    const { selectedItems } = this.state;
    const [customer] = selectedItems;
    this.setState({
      isLoading: true,
      isCustomerStudentsFormModalOpen: false,
    });

    updateRequestStatusCustomerStudent(user, customer.id, id, STUDENT_REQUEST_STATUS.POSTPONED, data)
      .then(res => {
        return getAllCustomerWithStudents(user);
      })
      .then(updateCustomers => {
        const currentCustomers = updateCustomers.filter(updateCustomer => updateCustomer.id === customer.id);
        this.setState({
          selectedItems: currentCustomers,
          items: updateCustomers,
          isLoading: false,
        });
      })
      .catch(error => {
        const errorText = propz.get(error, ['response', 'data', 'details', 'text'], '');
        console.error(errorText);
        this.setState({
          isLoading: false,
          isErrorModalOpen: true,
          errorMessage: errorText,
        });
      });
  };

  updateRequestStatusToNewCustomerStudentClick = id => {
    const { user } = this.props;
    const { selectedItems } = this.state;
    const [customer] = selectedItems;
    this.setState({
      isLoading: true,
      isCustomerStudentsFormModalOpen: false,
    });
    updateRequestStatusCustomerStudent(user, customer.id, id, STUDENT_REQUEST_STATUS.NEW)
      .then(res => {
        return getAllCustomerWithStudents(user);
      })
      .then(updateCustomers => {
        const currentCustomers = updateCustomers.filter(updateCustomer => updateCustomer.id === customer.id);
        this.setState({
          selectedItems: currentCustomers,
          items: updateCustomers,
          isLoading: false,
        });
      })
      .catch(error => {
        const errorText = propz.get(error, ['response', 'data', 'details', 'text'], '');
        console.error(errorText);
        this.setState({
          isLoading: false,
          isErrorModalOpen: true,
          errorMessage: errorText,
        });
      });
  };

  updateRequestStatusNoMatchCustomerStudentClick = id => {
    const { user } = this.props;
    const { selectedItems } = this.state;
    const [customer] = selectedItems;
    this.setState({
      isLoading: true,
      isCustomerStudentsFormModalOpen: false,
    });
    updateRequestStatusCustomerStudent(user, customer.id, id, STUDENT_REQUEST_STATUS.NO_MATCH)
      .then(res => {
        return getAllCustomerWithStudents(user);
      })
      .then(updateCustomers => {
        const currentCustomers = updateCustomers.filter(updateCustomer => updateCustomer.id === customer.id);
        this.setState({
          selectedItems: currentCustomers,
          items: updateCustomers,
          isLoading: false,
        });
      })
      .catch(error => {
        const errorText = propz.get(error, ['response', 'data', 'details', 'text'], '');
        console.error(errorText);
        this.setState({
          isLoading: false,
          isErrorModalOpen: true,
          errorMessage: errorText,
        });
      });
  };

  onDeleteStudentClick = id => {
    const { user } = this.props;
    const { selectedItems } = this.state;
    const [customer] = selectedItems;
    this.setState({
      isLoading: true,
      isCustomerStudentsFormModalOpen: false,
    });

    deleteCustomerStudent(user, customer.id, id)
      .then(res => {
        return getAllCustomerWithStudents(user);
      })
      .then(updateCustomers => {
        const currentCustomers = updateCustomers.filter(updateCustomer => updateCustomer.id === customer.id);
        if (customer.students.length > 1) {
          this.setState({
            selectedItems: currentCustomers,
            items: updateCustomers,
            isCustomerStudentsFormModalOpen: true,
            isLoading: false,
          });
        } else {
          this.setState({
            selectedItems: [],
            items: updateCustomers,
            isLoading: false,
          });
        }
      })
      .catch(error => {
        const errorText = propz.get(error, ['response', 'data', 'details', 'text'], '');
        console.error(errorText);
        this.setState({
          isLoading: false,
          isErrorModalOpen: true,
          errorMessage: errorText,
        });
      });
  };

  onDeleteStudentNoNotificationClick = id => {
    const { user } = this.props;
    const { selectedItems } = this.state;
    const [customer] = selectedItems;
    this.setState({
      isLoading: true,
      isCustomerStudentsFormModalOpen: false,
    });

    deleteCustomerStudentNoNotification(user, customer.id, id)
      .then(res => {
        return getAllCustomerWithStudents(user);
      })
      .then(updateCustomers => {
        const currentCustomers = updateCustomers.filter(updateCustomer => updateCustomer.id === customer.id);
        if (customer.students.length > 1) {
          this.setState({
            selectedItems: currentCustomers,
            items: updateCustomers,
            isCustomerStudentsFormModalOpen: true,
            isLoading: false,
          });
        } else {
          this.setState({
            selectedItems: [],
            items: updateCustomers,
            isLoading: false,
          });
        }
      })
      .catch(error => {
        const errorText = propz.get(error, ['response', 'data', 'details', 'text'], '');
        console.error(errorText);
        this.setState({
          isLoading: false,
          isErrorModalOpen: true,
          errorMessage: errorText,
        });
      });
  };

  onSubmitCustomerStudentsFormButtonClick = data => {
    const { selectedItems } = this.state;
    const { user } = this.props;
    const [customer] = selectedItems;

    this.setState({ isLoading: true });

    const toApprove = data.students
      .map((s, i) => ({
        customerStudentId: customer.students[i].id,
        schoolId: s.schoolId,
        formId: data.forms[i].formId!,
        studentId: s.studentId,
      }))
      .filter(x => x.formId && x.studentId);

    const toPostpone = data.students
      .map((s, i) => ({
        customerStudent: customer.students[i],
        comment: s.comment,
        commentEnabled: s.commentEnabled,
      }))
      .filter(({ customerStudent, comment, commentEnabled }) => {
        const isNew = customerStudent.requestStatus === STUDENT_REQUEST_STATUS.NEW;
        const changed = customerStudent.comment !== comment;
        return commentEnabled && (isNew || changed);
      });

    BPromise.all(
      toApprove.map(x =>
        approveStudent(user, x.schoolId, x.formId, x.customerStudentId, {
          studentId: x.studentId,
          customerId: customer.id,
        })
      )
    )
      .then(() => {
        return BPromise.all(
          toPostpone.map(({ customerStudent, comment }) =>
            this.onPostponeStudentRequestClick(customerStudent.id, { comment })
          )
        );
      })
      .then(() => {
        this.setState({
          isCustomerStudentsFormModalOpen: false,
          isLoading: false,
          selectedItems: toPostpone.length ? this.state.selectedItems : [],
        });
        this.setItems();
      })
      .catch(error => {
        const errorText = propz.get(error, ['response', 'data', 'details', 'text'], '');
        console.error(errorText);
        this.setState({
          isLoading: false,
          isCustomerStudentsFormModalOpen: false,
          isErrorModalOpen: true,
          errorMessage: errorText,
        });
      });
  };

  onSubmitBulkImageId = ({ bulkImageId }: { bulkImageId: string }) => {
    const { user } = this.props;
    const [customer] = this.state.selectedItems;

    this.setState({ isLoading: true });
    addCustomerPermissionsBulkImageId(user, customer.id, bulkImageId)
      .then(added => {
        const count = Array.isArray(added) ? added.length : 1;

        this.hideBulkImageModal();

        this.showBulkImageConfirmation(count);

        this.setItems();
      })
      .catch(err => {
        const msg = err?.response?.data?.details?.text || err.message;
        this.setState({
          isLoading: false,
          errorMessage: msg,
        });
      });
  };

  renderSendingError(): React.ReactNode {
    const { errorMessage, isErrorModalOpen } = this.state;

    return (
      <SimpleModal
        isOpen={isErrorModalOpen}
        title={'Error'}
        body={errorMessage}
        buttonCancelText={'Ok'}
        onCloseClick={this.onCloseErrorClick}
      />
    );
  }

  renderCustomerStudentsFormModal(): React.ReactNode {
    const { isCustomerStudentsFormModalOpen, selectedItems, students } = this.state;
    const { user } = this.props;

    const [customer] = selectedItems;

    return (
      <SimpleModal isOpen={isCustomerStudentsFormModalOpen} title="Customers linking" customClass="modal-wide">
        <CustomerStudentsForm
          customer={customer}
          allCustomerStudents={students}
          user={user}
          onCancel={this.onCancelCustomerStudentsFormButtonClick}
          onSubmit={this.onSubmitCustomerStudentsFormButtonClick}
          onDeleteStudentClick={this.onDeleteStudentClick}
          onDeleteStudentNoNotificationClick={this.onDeleteStudentNoNotificationClick}
          updateRequestStatusToNewCustomerStudentClick={this.updateRequestStatusToNewCustomerStudentClick}
          updateRequestStatusNoMatchCustomerStudentClick={this.updateRequestStatusNoMatchCustomerStudentClick}
        />
      </SimpleModal>
    );
  }

  renderBulkImageModal(): React.ReactNode {
    const { isBulkImageModalOpen, errorMessage } = this.state;
    return (
      <SimpleModal isOpen={isBulkImageModalOpen} title="Add Images by Bulk Image ID">
        {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}
        <CustomerBulkImageIdForm onCancel={this.hideBulkImageModal} onSubmit={this.onSubmitBulkImageId} />
      </SimpleModal>
    );
  }

  renderBulkImageConfirmation(): React.ReactNode {
    const { isBulkImageConfirmationOpen, bulkAddedCount } = this.state;
    return (
      <SimpleModal
        isOpen={isBulkImageConfirmationOpen}
        title="Permissions Added"
        body={`Successfully added ${bulkAddedCount} permission${
          bulkAddedCount !== 1 ? 's' : ''
        }. You can view all of this customer's permissions from the Customers list.`}
        buttonText="OK"
        onButtonClick={this.hideBulkImageConfirmation}
      />
    );
  }

  renderGrid(): React.ReactNode {
    const {
      items,
      sortDirection,
      sortColumnsName,
      isShowFilter,
      isDataFiltered,
      selectedItems,
      filters,
      isSelectAllChecked,
      currentPage,
      total,
    } = this.state;

    const actionItems = [
      {
        itemText: 'Approve user',
        onItemClick: this.onApproveStudentsClick,
        isActive: selectedItems.length === 1,
      },
      {
        itemText: 'Automatch',
        onItemClick: this.onAutomatchStudentsClick,
        isActive: true,
      },
      {
        itemText: 'Add image',
        onItemClick: this.showBulkImageModal,
        isActive: selectedItems.length === 1,
      },
    ];

    const filterOptions = {
      requestStatus: getSelectOptionForRequestStatus(),
      noAutoAcceptReason: getSelectOptionForNoAutoAcceptReason(),
    };

    return (
      <Grid
        dataItems={items}
        filters={filters}
        currentPage={currentPage}
        total={total}
        isSelectAllChecked={isSelectAllChecked}
        isDataFiltered={isDataFiltered}
        sortDirection={sortDirection}
        sortColumnsName={sortColumnsName}
        isShowFilter={isShowFilter}
        dataItemsSelected={selectedItems}
        columns={COLUMNS}
        actionItems={actionItems}
        options={filterOptions}
        onItemClick={this.onItemClick}
        onSortClick={this.onTableSortClick}
        onApplyFilterClick={this.onApplyFilterClick}
        onClearFilterClick={this.onClearFilterClick}
        onTableFilterChange={this.onTableFilterChange}
        onTableFilterClick={this.onTableFilterClick}
        setCurrentPageParams={this.setCurrentPageParams}
        onSelectAllClick={this.onSelectAllClick}
        onSelectAllOnPageClick={this.onSelectAllOnPageClick}
        onUnselectAllClick={this.onUnselectAllClick}
      />
    );
  }

  render() {
    const {
      isLoading,
      isCustomerStudentsFormModalOpen,
      isErrorModalOpen,
      isBulkImageModalOpen,
      isBulkImageConfirmationOpen,
    } = this.state;

    if (isLoading) {
      return <Loader />;
    }

    const classes =
      isCustomerStudentsFormModalOpen || isErrorModalOpen || isBulkImageModalOpen || isBulkImageConfirmationOpen
        ? 'mt-3 modal-open'
        : 'mt-3';

    return (
      <div className={classes}>
        {this.renderSendingError()}
        {this.renderCustomerStudentsFormModal()}
        {this.renderBulkImageModal()}
        {this.renderBulkImageConfirmation()}
        <div className="row">
          <div className="col-md-12">{this.renderGrid()}</div>
        </div>
      </div>
    );
  }
}
